<table class="example-table mat-elevation-z8" mat-table recycleRows [dataSource]="results$ | async">
  <!-- Position Column -->
  <ng-container matColumnDef="position">
    <th mat-header-cell *matHeaderCellDef >Position</th>
    <td mat-cell *matCellDef="let single; let i = index" class="leadboard-column-position">{{i + 1}}</td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>User</th>
    <td mat-cell *matCellDef="let single" class="leadboard-column-user">{{single.name}}</td>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef>Missed Calls</th>
    <td mat-cell *matCellDef="let single" class="leadboard-column-missedCalls">{{single.value}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="leadboard-header-row"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onClick(row)" class="leadboard-row"></tr>
</table>

